







































import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';

import CustomWarningComponent from '../components/CustomWarningComponent.vue';
import Loading from '../components/Loading.vue';
import SignInComponent from '../components/SignInComponent.vue';
import { EventUI } from '../models/event-ui';
import { eventUIStore } from '../store/event-ui';

@Component({
  components: {
    Loading,
    CustomWarningComponent,
    SignInComponent,
  },
})
export default class SignInPage extends Vue {
  isLoading = false;

  eventUI: EventUI = null;

  async mounted() {
    this.isLoading = true;
    const eventAlias = this.$route.params.alias;

    this.eventUI = await eventUIStore.fromAlias(eventAlias);
    this.isLoading = false;

    if (this.eventUI && !this.eventUI.is_online) {
      this.$router.replace({ name: 'sign-up', params: { alias: eventAlias }, replace: true });
    }
  }

  get hasFinished() {
    return moment().isAfter(this.eventUI.event.info.dates[this.eventUI.event.info.dates.length - 1].end);
  }
}
